import { lang } from '@ott/l10n';

export const getPreparedLocale = () => {
  return lang.includes('-')
    ? `${lang.slice(0, 2)}_${lang.slice(3, 5).toUpperCase()}`
    : `${lang}_${lang.toUpperCase()}`;
};
